import { defineAbility } from "@casl/ability"

export default (role) =>
  defineAbility((can) => {
    const { name, subscription, currentTrialDays, permissions } = role

    can("read", [
      "login",
      "sign-up",
      "password",
      "people",
      "project",
      "plans",
      "select-plan-to-continue",
      "billing-details",
      "qr-builder",
      "account",
      "qr-stats",
      "checkout",
      "incomplete"
    ])

    if (name === "Admin") {
      can("read", "current-plan")
      can("read", "admin-button")
      can(["read"], ["qrs", "people", "settings", "billing", "whitelabel", "single-sign-on"])
    }

    if (name === "Editor") {
      if (subscription === "FREE" || (subscription === "TRIAL" && currentTrialDays > 14)) {
        can("read", "trial-expired")
      }
    }

    permissions.forEach((x) => {
      const action = x.split(".").pop()

      can(action, x)
    })
  })
